var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minisite-button-container",class:'button-' + _vm.buttonStyle.position},[_c('div',{style:(_vm.getButtonStyle)},[_c('basic-text',{attrs:{"data":_vm.data}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }